// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"c3da4ad2","488":"45c397d3","988":"c7299124"}[chunkId] + ".chunk.js";
};